import { useMemo } from 'react';
import useMonarchStore from '@/stores/monarchStore';
import { computeComparisonPeriods, formatDateRange } from '@/lib/dateComparison';

export function useComparisonPeriods() {
  const dateRange = useMonarchStore((s) => s.ui.dateRange);
  const start = dateRange.start instanceof Date ? dateRange.start : new Date(dateRange.start);
  const end = dateRange.end instanceof Date ? dateRange.end : new Date(dateRange.end);

  return useMemo(() => {
    const periods = computeComparisonPeriods(start, end);
    return {
      compareEnabled: dateRange.compareEnabled,
      popTooltip: `vs ${formatDateRange(periods.pop.start, periods.pop.end)}`,
      yoyTooltip: `vs ${formatDateRange(periods.yoy.start, periods.yoy.end)}`,
      periods,
    };
  }, [start, end, dateRange.compareEnabled]);
}
